import { render, staticRenderFns } from "./AssistantCatSelectionDialog.vue?vue&type=template&id=117fb6f2&scoped=true"
import script from "./AssistantCatSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./AssistantCatSelectionDialog.vue?vue&type=script&lang=ts"
import style0 from "./AssistantCatSelectionDialog.vue?vue&type=style&index=0&id=117fb6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117fb6f2",
  null
  
)

export default component.exports